<template>
  <div v-if="currentPosition && !currentPosition.valid" style="float: right; padding-right: 2px">
    <el-tooltip :content="$t('No GPS')">
      <i class="fas fa-location-crosshairs-slash" style="padding-left:2px; color:red"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'InvalidPosition',

  props: {
    currentPosition: {
      type: Object,
      default: null
    }
  }

}
</script>
